<template>
	<div class="bubble" :class="visible ? 'visible-transition scale transition-delay-'+delay+' '+cssClass+'' : 'invisible-transition scale '+cssClass+''">
		<div>
			<h6>{{ title }}<span class="bubble-value">{{ value }}</span></h6>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
	    visible: {
        default: () => false
	    },
	    delay: {
        default: () => 0
	    },
	    title: {
        default: () => 'Country'
	    },
	    value: {
        default: () => '0%'
	    },
			cssClass: {
				default: () => 'Country'
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/Bubble.vue